import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Trophy, X } from "lucide-react";
import { api } from "../../lib/api";

export function useCountdown(end) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const ms = Math.max(0, new Date(end || 0).getTime() - now);
  return { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60, over: ms === 0 };
}

const HIDE = ["/contest", "/call-center", "/rep", "/agreements/sign", "/live/", "/session/", "/meet/", "/q/", "/dashboard", "/admin", "/tv", "/careers/me", "/careers/interview/", "/seo-center", "/party", "/doc/", "/record/", "/verify/"];
export function ContestBanner() {
  const { pathname } = useLocation();
  const [c, setC] = useState(null);
  const [closed, setClosed] = useState(sessionStorage.getItem("lif_contest_x") === "1");
  useEffect(() => { api.get("/public/contest").then((r) => setC(r.data)).catch(() => {}); }, []);
  const t = useCountdown(c?.ends_at);
  if (!c || c.status !== "open" || t.over || closed || HIDE.some((p) => pathname.startsWith(p))) return null;
  return (
    <div className="bg-[var(--ink)] text-white text-xs md:text-sm px-4 py-2 flex items-center justify-center gap-3 relative z-40" data-testid="contest-banner">
      <Trophy className="w-4 h-4 text-[var(--gold)] shrink-0" />
      <span className="truncate"><b className="text-[var(--gold)]">Win a $25,000 wedding</b> · 2nd place $10K · ends in <b data-testid="contest-banner-countdown">{t.d}d {t.h}h {t.m}m {t.s}s</b></span>
      <Link to="/contest" className="bg-[var(--gold)] rounded-full px-3 py-1 text-[11px] uppercase tracking-[0.14em] shrink-0" data-testid="contest-banner-cta">Enter now</Link>
      <button onClick={() => { sessionStorage.setItem("lif_contest_x", "1"); setClosed(true); }} aria-label="Close" className="absolute right-3"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
}
